import React, { useEffect, useState } from "react";
import { a4PreviewHtml } from "@/lib/print";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export function PreviewDialog({ open, onOpenChange, doc, business, bill, quotation = false }) {
  const [html, setHtml] = useState("");
  useEffect(() => { if (open && doc) a4PreviewHtml(doc, business, bill, quotation).then(setHtml); }, [open, doc, business, bill, quotation]);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white max-w-4xl h-[90vh] flex flex-col" data-testid="di-preview-dialog">
        <DialogHeader><DialogTitle>{quotation ? "Quotation Preview" : "Invoice Preview"}</DialogTitle><DialogDescription className="sr-only">Preview of the printed document</DialogDescription></DialogHeader>
        <iframe title="invoice-preview" srcDoc={html} className="flex-1 w-full border rounded bg-white" data-testid="di-preview-frame" />
      </DialogContent>
    </Dialog>
  );
}
